import { render } from "./NioIcon.vue?vue&type=template&id=bd02ec1c"
import script from "./NioIcon.vue?vue&type=script&lang=js"
export * from "./NioIcon.vue?vue&type=script&lang=js"
script.render = render

export default script